import React, {useState, useEffect} from 'react'
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from 'react-router-dom';

const UserTopicItem = ({obj}) => {

    const [hover, setHover] = useState(false);

    function handleHover(state){
        setHover(state);
    };

    const styles = {
        item: {
            background: '#fff',
            marginBottom: 20,
            padding: '10px 20px',
            border: '1px solid #ccc',
            borderRadius: 5,
            position: 'relative'
        },
        title:{
            color: '#363636',
            fontSize: 16,
            fontWeight: 600,
            marginBottom: 5,
        },
        description:{
            color: '#363636',
            fontSize: 13,
        },
        link:{
            textDecoration: 'none'
        },
        actions: {
            container: {
                position: 'absolute',
                top: 3,
                right: 3
            },
            btn:{
                color: hover?'#00667d':'#888',
                background: hover?'#efefef':'#fff',
                padding: '3px 10px',
                border: 'none',
                borderRadius: 3,
                fontSize: 15,
                outline: 'none',
                boxShadow: 'none',
                transition: 'none',
            },
            option:{
                fontSize: 14,
            },
            optionRed:{
                color: '#ff6d6d',
                fontSize: 14,
            },
        },
    }

    function actions(){
        return(
            <div class="dropdown">
                <button type="button" data-toggle="dropdown" style={styles.actions.btn} onMouseEnter={()=>handleHover(true)} onMouseLeave={()=>handleHover(false)}>
                    <FontAwesomeIcon icon={faEllipsisV} />
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                    <a href={`/topic/${obj.Slug}`} class="dropdown-item" style={styles.actions.option}>
                        Preview
                    </a>
                    <div className="dropdown-divider"></div>
                    <Link to={`/topic/edit/${obj.Slug}`} class="dropdown-item" style={styles.actions.option}>
                        Edit
                    </Link>
                    <div className="dropdown-divider"></div>
                    <Link to={`/topic/settings/${obj.Slug}`} class="dropdown-item" style={styles.actions.option}>
                        Settings
                    </Link>
                    <div className="dropdown-divider"></div>
                    <Link onClick={()=>{confirmDelete()}} class="dropdown-item" style={styles.actions.optionRed}>
                        Delete
                    </Link>
                </div>
            </div>
        )
    }

    return (
        <div style={styles.item}>
            <div style={styles.actions.container}>{actions()}</div>
            <a href={`/topic/${obj.Slug}`} style={styles.link}>
                <h2 style={styles.title}>{obj.Title}</h2>
            </a>
            <div style={styles.description}>{obj.Description}</div>
        </div>
    )
}

export default UserTopicItem